import { call, put, takeEvery } from 'redux-saga/effects'

import * as Api from '../api/team-chat-api';

function* fetchTeamChatConfig(action) {
    try {
        const config = yield call(Api.fetchTeamChatConfig);
        yield put({
            type: 'TEAMCHAT_CONFIG_FETCH_SUCCEEDED',
            payload: { config }
        });

        action.onComplete && action.onComplete(config);
    } catch (e) {
        yield put({
            type: 'TEAMCHAT_CONFIG_FETCH_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* activateConversation(action) {
    try {
        yield call(Api.activateConversation, action.payload.conversationId);
        yield put({
            type: 'TEAMCHAT_ACTIVATE_CONVERSATION_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'TEAMCHAT_ACTIVATE_CONVERSATION_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* deactivateConversation(action) {
    try {
        yield call(Api.deactivateConversation, action.payload.conversationId);
        yield put({
            type: 'TEAMCHAT_DEACTIVATE_CONVERSATION_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'TEAMCHAT_DEACTIVATE_CONVERSATION_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* deactivateAllConversations(action) {
    try {
        yield call(Api.deactivateAllConversations);
        yield put({
            type: 'TEAMCHAT_DEACTIVATE_ALL_CONVERSATIONS_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'TEAMCHAT_DEACTIVATE_ALL_CONVERSATIONS_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* showNewConversation(action) {
    try {
        yield call(Api.showNewConversation, action.payload.invitees);
        yield put({
            type: 'TEAMCHAT_SHOW_NEW_CONVERSATION_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'TEAMCHAT_SHOW_NEW_CONVERSATION_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* hideNewConversation(action) {
    try {
        yield call(Api.hideNewConversation);
        yield put({
            type: 'TEAMCHAT_HIDE_NEW_CONVERSATION_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'TEAMCHAT_HIDE_NEW_CONVERSATION_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* enableWidget(action) {
    try {
        yield call(Api.enableWidget);
        yield put({
            type: 'TEAMCHAT_WIDGET_ENABLE_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'TEAMCHAT_WIDGET_ENABLE_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* disableWidget(action) {
    try {
        yield call(Api.disableWidget);
        yield put({
            type: 'TEAMCHAT_WIDGET_DISABLE_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'TEAMCHAT_WIDGET_DISABLE_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* openWidget(action) {
    try {
        yield call(Api.openWidget);
        yield put({
            type: 'TEAMCHAT_WIDGET_OPEN_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'TEAMCHAT_WIDGET_OPEN_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* closeWidget(action) {
    try {
        yield call(Api.closeWidget);
        yield put({
            type: 'TEAMCHAT_WIDGET_CLOSE_SUCCEEDED'
        });
    } catch (e) {
        yield put({
            type: 'TEAMCHAT_WIDGET_CLOSE_FAILED',
            payload: {
                message: e.message || e
            }
        });
    }
}

function* watchGetTeamChatConfig() {
    yield takeEvery('TEAMCHAT_CONFIG_FETCH_REQUESTED', fetchTeamChatConfig);
}

function* watchActivateConversation() {
    yield takeEvery('TEAMCHAT_ACTIVATE_CONVERSATION_REQUESTED', activateConversation);
}

function* watchDeactivateConversation() {
    yield takeEvery('TEAMCHAT_DEACTIVATE_CONVERSATION_REQUESTED', deactivateConversation);
}

function* watchDeactivateAllConversations() {
    yield takeEvery('TEAMCHAT_DEACTIVATE_ALL_CONVERSATIONS_REQUESTED', deactivateAllConversations);
}

function* watchShowNewConversation() {
    yield takeEvery('TEAMCHAT_SHOW_NEW_CONVERSATION_REQUESTED', showNewConversation);
}

function* watchHideNewConversation() {
    yield takeEvery('TEAMCHAT_HIDE_NEW_CONVERSATION_REQUESTED', hideNewConversation);
}

function* watchEnableWidget() {
    yield takeEvery('TEAMCHAT_WIDGET_ENABLE_REQUESTED', enableWidget);
}

function* watchDisableWidget() {
    yield takeEvery('TEAMCHAT_WIDGET_DISABLE_REQUESTED', disableWidget);
}

function* watchOpenWidget() {
    yield takeEvery('TEAMCHAT_WIDGET_OPEN_REQUESTED', openWidget);
}

function* watchCloseWidget() {
    yield takeEvery('TEAMCHAT_WIDGET_CLOSE_REQUESTED', closeWidget);
}

export default [watchGetTeamChatConfig, watchActivateConversation, watchDeactivateConversation, watchDeactivateAllConversations, watchShowNewConversation, watchHideNewConversation, watchEnableWidget, watchDisableWidget, watchOpenWidget, watchCloseWidget];
